import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './index.scss';
import { Modal } from 'react-bootstrap';
import backicon from '../../../../../Assets/icons/backIcon.svg';
import downloadIcon from '../../../../../Assets/icons/download.svg';
import plusIcon from '../../../../../Assets/icons/plus-circle.svg';
import MinusIcon from '../../../../../Assets/icons/Minus-circle.svg'

//plus-circle.svg Minus-circle.svg

const ServicesGetPassDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState(null);
    const [selectedAssignee, setSelectedAssignee] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [showRemarkModal, setShowRemarkModal] = useState(false); // Add state for remark modal
    const [remark, setRemark] = useState(''); // Add state for remark
    const [assigneeList] = useState([
        { name: 'Telecaller 1', assignedLeads: 5 },
        { name: 'Telecaller 2', assignedLeads: 10 },
        { name: 'Telecaller 3', assignedLeads: 3 },
        { name: 'Sales Manager 1', assignedLeads: 8 },
        { name: 'Sales Manager 2', assignedLeads: 6 },
        { name: 'Sales Manager 3', assignedLeads: 2 },
    ]);
    const [issueId, setIssueId] = useState(0);
    const IssueList = [{
        id: 1,
        complainNo: 'VD001',
        Technicianname: 'Sudhir Kadam',
        complenDiscription: 'Breek Shoo Issue',
        Repair: 'Break Shoe',
        WorkShop: 'Andheri Work Shop',
        EstimateCost: '5000',
        EstimateTime: '5Hrs',
        IssueStatus: 'Inprogress',
        Remark: 'Find Break Shoe',
        part: 'Brack Drun',
        PartType: 'Spare part',
        Issue: 'Abnormal Noise',
        itemName: 'Brack Drun',
        GoodsQty: '1',
        RepairStatus: 'Done'
    },
    {
        id: 2,
        complainNo: 'VD001',
        Technicianname: 'Sudhir Kadam',
        complenDiscription: 'Breek Shoo Issue',
        Repair: 'Break Shoe',
        WorkShop: 'Andheri Work Shop',
        EstimateCost: '5000',
        EstimateTime: '5Hrs',
        IssueStatus: 'Inprogress',
        Remark: 'Find Break Shoe',
        part: 'Brack Drun',
        PartType: 'Spare part',
        Issue: 'Abnormal Noise',
        itemName: 'Brack Drun',
        GoodsQty: '1',
        RepairStatus: 'Done'

    },
    {
        id: 3,
        complainNo: 'VD001',
        Technicianname: 'Sudhir Kadam',
        complenDiscription: 'Breek Shoo Issue',
        Repair: 'Break Shoe',
        WorkShop: 'Andheri Work Shop',
        EstimateCost: '5000',
        EstimateTime: '5Hrs',
        IssueStatus: 'Inprogress',
        Remark: 'Find Break Shoe',
        part: 'Brack Drun',
        PartType: 'Spare part',
        Issue: 'Abnormal Noise',
        itemName: 'Brack Drun',
        GoodsQty: '1',
        RepairStatus: 'Done'


    }
    ]

    const [filteredAssigneeList, setFilteredAssigneeList] = useState(assigneeList);


    const handleSearchChange = (event) => {
        const value = event.target.value.toLowerCase();
        setSearchTerm(value);
        const filteredList = assigneeList.filter(assignee =>
            assignee.name.toLowerCase().includes(value)
        );
        setFilteredAssigneeList(filteredList);
    };

    const handleAssignClick = (type) => {
        setModalType(type);
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
        setSelectedAssignee('');
    };

    const handleAssigneeChange = (event) => {
        setSelectedAssignee(event.target.value);
    };

    const handleAssign = () => {
        console.log(`Assigning ${modalType} to ${selectedAssignee}`);
        // Implement your assignment logic here
        setShowModal(false);
    };

    const handleOpenModal = (type) => {
        setModalType(type);
        setShowModal(true);
    };

    const handleOpenRemarkModal = () => {
        setShowRemarkModal(true);
    };

    const handleCloseRemarkModal = () => {
        setShowRemarkModal(false);
    };

    const handleSaveRemark = () => {
        // console.log('Remark:', remark);
        // Implement your logic to save the remark here
        setShowRemarkModal(false);
    };

    const onClickSetIssueId = (id) => {
        if (id == '') {
            setIssueId('')
        } else {
            setIssueId(id)
        }
    }
    const assigneeTypeFilter = modalType === 'Telecaller' ? 'Telecaller' : 'Sales Manager';
    const filteredAssignees = assigneeList.filter(assignee => assignee.name.includes(assigneeTypeFilter));

    return (
        <div>
            <div className='OnboardManagamentContainer '>
                <div className='OnboardManagamentbuttonContainer  col-xl-4 col-lg-12 mt-2 mb-2'>
                    <div className="backbutton mt-2 mb-2">
                        <img src={backicon} alt="back" />
                        <span className="backbtntitle">Pass Details</span>
                    </div>
                </div>
                <div className='totalvaluescontainer col-xl-8 col-lg-12 mt-2 mb-2'>
                    <div className='downloadiconwrapper downloadIcon'>
                        <h6 className='downloadTitle'>Update Reg. No.</h6>
                    </div>
                    <button className='addcustomerbutton' onClick={() => navigate('add-Job-Card')}>
                        Back
                    </button>
                </div>
            </div>
            <div className='details-container grid border'>
                <div>
                    <span className="lable">Personal Details</span>
                </div>
                <div className="details-section">
                    <div className="details-grid">
                        <div className="details-item">
                            <span className="details-label">Transection No.:</span>
                            <span className="details-value">TN-1151</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Proposal Type:</span>
                            <span className="details-value">Against Proposal</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Customer Name:</span>
                            <span className="details-value">Ankit Mujumdar</span>

                        </div>
                        <div className="details-item">
                            <span className="details-label">Contact No :</span>
                            <span className="details-value">8835647674</span>

                        </div>
                        <div className="details-item">
                            <span className="details-label">Customer Type:</span>
                            <span className="details-value">Individual</span>

                        </div>
                        <div className="details-item">
                            <span className="details-label">Quotation Type:</span>
                            <span className="details-value">New Lead</span>

                        </div>
                        <div className="details-item">
                            <span className="details-label">Customer Visit Type:</span>
                            <span className="details-value">Showroom Visit</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Visit Date &&  Time:</span>
                            <span className="details-value">11/2/2023-11:00 pm</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Dealer Branch:</span>
                            <span className="details-value">Andheri East</span>
                        </div>

                        <div className="details-item">
                            <span className="details-label">Sale Parson:</span>
                            <span className="details-value">Ankit Mujumdar</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Address:</span>
                            <span className="details-value">Mira Road</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">PIN Code:</span>
                            <span className="details-value">450445</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">City:</span>
                            <span className="details-value">Thane </span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">State:</span>
                            <span className="details-value">Maharashtra</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Country:</span>
                            <span className="details-value">India</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Allotment Status:</span>
                            <span className="details-value">Alloted</span>
                        </div>
                       
                    </div>
                </div>
            </div>
            <div className='details-container grid border'>
                <div>
                    <span className="lable">Vechile Details</span>
                </div>
                <div className="details-section">
                    <div className="details-grid">
                        <div className="details-item">
                            <span className="details-label">Product Name:</span>
                            <span className="details-value">Scooter</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Sub Product name:</span>
                            <span className="details-value">Scooter</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Make:</span>
                            <span className="details-value">Honda</span>

                        </div>
                        <div className="details-item">
                            <span className="details-label">Model :</span>
                            <span className="details-value">Activa 6G</span>

                        </div>
                        <div className="details-item">
                            <span className="details-label">Veriant:</span>
                            <span className="details-value">DLX</span>

                        </div>
                       
                        <div className="details-item">
                            <span className="details-label">Veriant Color:</span>
                            <span className="details-value">Black</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Fual Type:</span>
                            <span className="details-value">Petrol</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Term & Condition:</span>
                            <span className="details-value"></span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">RTO:</span>
                            <span className="details-value">MH-04</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Extended Warranty:</span>
                            <span className="details-value">-</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='details-container grid border'>
                <div>
                    <span className="lable">Other Vechile Details</span>
                </div>
                <div className="details-section">
                    <div className="details-grid">
                        <div className="details-item">
                            <span className="details-label">Chassis No:</span>
                            <span className="details-value">CH-89</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Engine No.:</span>
                            <span className="details-value">ENG124</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Temp. Registration No.:</span>
                            <span className="details-value">89464763727387</span>

                        </div>
                        <div className="details-item">
                            <span className="details-label">Mfg Year & Month :</span>
                            <span className="details-value">11/12/2022</span>

                        </div>
                        <div className="details-item">
                            <span className="details-label">Location:</span>
                            <span className="details-value">Mumbai</span>

                        </div>
                       
                    </div>
                </div>
            </div>
            <div className='details-container grid border'>
                <div>
                    <span className="lable">Payment Details</span>
                </div>
                <div className="details-section">
                    <div className="details-grid">
                        <div className="details-item">
                            <span className="details-label">Payment Type:</span>
                            <span className="details-value">Online</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">OutStanding Amount:</span>
                            <span className="details-value">145</span>
                        </div>
                        <div className="details-item">
                            <span className="details-label">Payment Status:</span>
                            <span className="details-value">Full Payment</span>

                        </div>
                                           </div>
                </div>
            </div>
            {/* <div className='OnboardManagamentContainer '>
                <div className='OnboardManagamentbuttonContainer  col-xl-4 col-lg-12'>
                    <h5>Issue Details</h5>
                </div>
                <div className='totalvaluescontainer col-xl-8 col-lg-12 '>
                    <button className='addcustomerbutton' onClick={() => navigate('add-Job-Card')}>
                        Add Issue
                    </button>
                </div>
            </div> */}
            {/* <div className='issue-list-parent-container'>
           
             {IssueList?.map((issueDetails) => (
                <div className='issue-list-container'>
                    <div className="details-section">
                        <div className="details-grid">
                            <div className="details-item">
                                <span className="details-label">complain No:</span>
                                <span className="details-value">{issueDetails?.complainNo}</span>

                            </div>
                            <div className="details-item">
                                <span className="details-label">Technician Name :</span>
                                <span className="details-value">{issueDetails?.Technicianname}</span>
                            </div>
                            <div className="details-item">
                                <span className="details-label">complen Discription:</span>
                                <span className="details-value">{issueDetails?.complenDiscription}</span>
                            </div>
                            <div className="details-item">
                                <span className="details-label">Repair:</span>
                                <span className="details-value">{issueDetails?.Repair}</span>

                            </div>
                            <div className="details-item">
                                <span className="details-label">WorkShop:</span>
                                <span className="details-value">{issueDetails?.WorkShop}</span>
                            </div>
                            <div className="details-item">
                                <span className="details-label">Estimate Cost:</span>
                                <span className="details-value">{issueDetails?.EstimateCost}</span>
                            </div>
                            <div className="details-item">
                                <span className="details-label">Estimate Time:</span>
                                <span className="details-value">{issueDetails?.EstimateTime}</span>
                            </div>
                         
                            {issueDetails?.id === issueId ?(
                            <div
                                onClick={() => { onClickSetIssueId('') }}>
                                <img
                                    src={MinusIcon}
                                    // alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                                    className="accordion-icon"
                                />
                            </div>
                            ) :
                            <div
                            onClick={() => { onClickSetIssueId(issueDetails?.id) }}>
                            <img
                                src={plusIcon}
                                // alt={isAccordionExpanded(parentMenu.parentId) ? 'Expanded' : 'Collapsed'}
                                className="accordion-icon"
                            />
                        </div>}
                        </div>
                 MinusIcon
                        <div>
                            {issueDetails?.id === issueId && (
                                <div>
                                <div className="details-grid">
                                    <div className="details-item">
                                        <span className="details-label">Issue Status:</span>
                                        <span className="details-value">{issueDetails?.IssueStatus}</span>
                                    </div>
                                    <div className="details-item">
                                        <span className="details-label">Remark:</span>
                                        <span className="details-value">{issueDetails?.Remark}</span>
                                    </div>
                                    <div className="details-item">
                                        <span className="details-label">Part:</span>
                                        <span className="details-value">{issueDetails?.part}</span>
                                    </div>
                                    <div className="details-item">
                                        <span className="details-label">PartType:</span>
                                        <span className="details-value">{issueDetails?.PartType}</span>
                                    </div>
                                    <div className="details-item">
                                        <span className="details-label">Issue:</span>
                                        <span className="details-value">{issueDetails?.Issue} </span>
                                    </div>

                                    <div className="details-item">
                                        <span className="details-label">Item Name:</span>
                                        <span className="details-value">{issueDetails?.itemName}</span>
                                    </div>
                                    <div className="details-item">
                                        <span className="details-label">Goods Qty:</span>
                                        <span className="details-value">{issueDetails?.GoodsQty}</span>
                                    </div>
                                    <div className="details-item">
                                        <span className="details-label">Repair Status:</span>
                                        <span className="details-value">{issueDetails?.RepairStatus}</span>
                                    </div>
                                </div>
                                   <div className='OnboardManagamentContainer '>
                                   <div className='OnboardManagamentbuttonContainer  col-xl-4 col-lg-12'>
                                       <h5>Issue Details</h5>
                                   </div>
                                   <div className='totalvaluescontainer col-xl-8 col-lg-12 '>
                                       <button className='addcustomerbutton' onClick={() => navigate('add-Job-Card')}>
                                           Add New Parts
                                       </button>
                                       <button className='addcustomerbutton' onClick={() => navigate('add-Job-Card')}>
                                           Edit
                                       </button>
                                   </div>
                               </div>
                               </div>
                            )}
                        </div>
                    </div>
                </div>
             ))}
            </div> */}
            {/* {showModal && (
                <Modal isPresales={true} show={showModal} onHide={handleModalClose} centered>
                    <span className='modalheading'>Select {modalType}</span>
                    <input
                        type="text"
                        placeholder="Search"
                        className="leadmodalsearch mt-2 mb-2"
                        value={searchTerm}
                        onChange={handleSearchChange}
                    />
                    <div className="assignee-list">
                        {filteredAssignees.map((assignee, index) => (
                            <div key={index} className="assignee-item mt-2">
                                <label htmlFor={`assignee-${index}`}>{assignee.name}</label>
                                <div className='countcontainer'>
                                    <label htmlFor={`assignee-${index}`} className='counttotal'> {assignee.assignedLeads} leads Assigned</label>
                                    <input
                                        type="radio"
                                        id={`assignee-${index}`}
                                        name="assignee"
                                        value={assignee.name}
                                        onChange={handleAssigneeChange}
                                        checked={selectedAssignee === assignee.name}
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className='modalbuttons mt-2 mb-2'>
                        <button onClick={handleModalClose} className='leadbtn'>Cancel</button>
                        <button onClick={handleAssign} className='leadbtn'>Assign </button>
                    </div>
                </Modal>
            )} */}

            {/* {showRemarkModal && (
                <Modal show={showRemarkModal} onHide={handleCloseRemarkModal} centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Add Remark</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <textarea
                            rows="4"
                            className="form-control"
                            placeholder="Enter your remark here..."
                            value={remark}
                            onChange={(e) => setRemark(e.target.value)}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <button className='btn btn-secondary' onClick={handleCloseRemarkModal}>Cancel</button>
                        <button className='btn btn-primary' onClick={handleSaveRemark}>Save Remark</button>
                    </Modal.Footer>
                </Modal>
            )} */}
        </div>
    );
};

export default ServicesGetPassDetails;
